// extracted by mini-css-extract-plugin
export default {"root":"MediaContainer__root--mw3s8O","lightBackground":"MediaContainer__lightBackground--ORY5p-"};